//**************************************************************************************************
//  フッター
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { Component } from '@angular/core';

import { CommonModule } from '@angular/common';

import { MatToolbarModule } from '@angular/material/toolbar';

import { TranslatePipe } from "@ngx-translate/core";

import { AppConst } from '../../app-const';

import { SessionService } from '../service/session.service';
import { Session } from '../../class/session';

import { FireSysAdmin } from '../../class/fire/sys_admin';
import { FireOpAdmin } from '../../class/fire/op_admin';
import { FireOpUser } from '../../class/fire/op_user';
import { FireGroup } from '../../class/fire/group';
import { FireOpr } from '../../class/fire/opr';

//==================================================================================================
//  Component
//==================================================================================================
@Component({
  selector: 'app-footer',
  imports: [
    CommonModule,
    TranslatePipe,
    MatToolbarModule
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
//==================================================================================================
//  class
//==================================================================================================
export class FooterComponent {
  //================================================================================================
  //  変数定義
  //============================|===================================================================
  isLogin                       : boolean                 = false;
  //------------------------------------------------------------------------------------------------
  sessionUid                    : string | null           = null;                                   //  セッション情報：UID
  sessionSysAdmin               : FireSysAdmin | null     = null;                                   //  セッション情報：システム管理者
  sessionOpAdmin                : FireOpAdmin | null      = null;                                   //  セッション情報：OP管理者
  sessionOpUser                 : FireOpUser | null       = null;                                   //  セッション情報：CAユーザー
  sessionGroup                  : FireGroup | null        = null;                                   //  セッション情報：グループ
  sessionOpr                    : FireOpr | null          = null;                                   //  セッション情報：OPレジストリ
  //------------------------------------------------------------------------------------------------
  time                          = new Date();
  intervalId                    : any;
  appConst                      = AppConst;
  //================================================================================================
  //  コンストラクタ
  //============================|===================================================================
  constructor(
    private sessionService: SessionService) { }
  //================================================================================================
  //  初期処理
  //================================================================================================
  ngOnInit(): void {
    this.sessionService.sessionState.subscribe((session: Session)=> {
      if (session) {
        this.isLogin              = session.isLogin;
        this.sessionUid           = session.uid;
        this.sessionSysAdmin      = session.sysAdmin;
        this.sessionOpAdmin       = session.opAdmin;
        this.sessionOpUser        = session.opUser;
        this.sessionGroup         = session.group;
        this.sessionOpr           = session.opr;
      }
    })
    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);
  }
  //================================================================================================
  //  終了処理
  //================================================================================================
  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }
}
